export default "__VITE_ASSET__CjQAtlJF__"